import React, { useState } from 'react';

export default function Login() {
  const [mode, setMode] = useState('login');

  return (
    <div className="page-wrapper">
      <div className="container" style={{ maxWidth: 480 }}>
        <div className="card">
          <div className="card-header">
            <h4>{mode === 'login' ? 'Sign In' : 'Register'}</h4>
          </div>
          <div className="card-body">
            <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
              <button
                className={`btn ${mode === 'login' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setMode('login')}
                style={{ flex: 1 }}
              >Login</button>
              <button
                className={`btn ${mode === 'register' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setMode('register')}
                style={{ flex: 1 }}
              >Register</button>
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" placeholder="you@example.com" />
            </div>

            {mode === 'register' && (
              <>
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input type="text" className="form-control" placeholder="Your name" />
                </div>
                <div className="form-group">
                  <label className="form-label">Phone</label>
                  <input type="tel" className="form-control" placeholder="555-555-5555" />
                </div>
              </>
            )}

            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" className="form-control" placeholder="••••••••" />
            </div>

            {mode === 'register' && (
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input type="password" className="form-control" placeholder="••••••••" />
              </div>
            )}

            <button className="btn btn-primary btn-block" style={{ marginTop: '1rem' }}>
              {mode === 'login' ? 'Sign In' : 'Create Account'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
